import { render, staticRenderFns } from "./deploy-confirm.vue?vue&type=template&id=6375c8fa&scoped=true&"
import script from "./deploy-confirm.vue?vue&type=script&lang=js&"
export * from "./deploy-confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6375c8fa",
  null
  
)

export default component.exports